module.exports = __webpack_public_path__ + "img/5_002.bb078747.webp";